import { __assign } from "tslib";
import React, { useContext } from 'react';
import { HeadingLevelContext } from '../context';
/**
 * Render a heading that matches the level of the current heading level context
 */
var Heading = function (props) {
    var headingLevel = useContext(HeadingLevelContext);
    // Keep the heading level from going above 6
    // But keep it from going below 2 -- we want h1s to be explicit to avoid any mess ups
    var Tag = "h".concat(Math.max(Math.min(headingLevel, 6), 2));
    return React.createElement(Tag, __assign({}, props));
};
Heading.displayName = 'Heading';
export default Heading;
//# sourceMappingURL=Heading.js.map